import axios from "../axios";
import api from "@/store/api";

export const state = {
  prompts: null,
}

export const mutations = {
  SET_COVER_ART_STATE(state, { key, value }) {
    state[key] = value
  },
}

export const actions = {
  async get_cover_art_prompts ({ commit }) {
    try {
      commit('SET_REQ_STATUS', 'fetching')
      const {data} = await axios.get(api.coverArt.prompts)
      const { _rev, ...config } = data
      commit('SET_COVER_ART_STATE', {key: 'prompts', value: config})
      commit('SET_REQ_STATUS', 'idles')
    } catch (err) {
      commit('SET_REQ_STATUS', 'failed')
    }
  },
  async update_cover_art_prompts ({ state, commit }) {
    try {
      commit('SET_REQ_STATUS', 'sending')
      await axios.put(api.coverArt.prompts, state.prompts)
      commit('SET_REQ_STATUS', 'idles')
    } catch (err) {
      commit('SET_REQ_STATUS', 'failed')
    }
  },
}